module.exports = __webpack_public_path__ + "static/stone-7f6ea717cb3b19f65f1254ea6d4fcb4f.jpg";